"use client";
import { Col, Container, Row } from "react-bootstrap";
import about1 from "../../public/assets/images/about/ab-1.png";
import about2 from "../../public/assets/images/about/ab-2.png";
import about3 from "../../public/assets/images/about/ab-3.png";
import "../app/about/about.css";
import Image from "next/image";
import { useEffect } from "react";
import WhyUs from "@/components/WhyUs";
import ExperiencesCard from "@/components/ExperiencesCard";
import AboutHeroSection from "@/components/AboutHeroSection";

const AboutSection = ({ title, highlight, content, image, reverse }) => (
  <Row className="gy-4">
    {reverse ? (
      <>
        <Col lg={6} md={12} className="align-self-center responsive-order-2">
          <h3 className="com-title reveal fade-left">
            {title} <span>{highlight}</span>
          </h3>
          {content.map((text, index) => (
            <p className="reveal fade-bottom" key={index}>
              {text}
            </p>
          ))}
        </Col>
        <Col
          lg={6}
          md={12}
          className="align-self-center reveal fade-right responsive-order-1"
        >
          <Image
            src={image}
            alt="about-img"
            height={500}
            width={500}
            className="img-fluid mx-auto d-block"
          />
        </Col>
      </>
    ) : (
      <>
        <Col lg={6} md={12} className="align-self-center reveal fade-left">
          <Image
            src={image}
            alt="about-img"
            height={500}
            width={500}
            className="img-fluid mx-auto d-block"
          />
        </Col>
        <Col lg={6} md={12} className="align-self-center">
          <h3 className="com-title reveal fade-right">
            {title} <span>{highlight}</span>
          </h3>
          {content.map((text, index) => (
            <p className="reveal fade-bottom" key={index}>
              {text}
            </p>
          ))}
        </Col>
      </>
    )}
  </Row>
);

export default function AboutPage() {
  useEffect(() => {
    const reveal = () => {
      const reveals = document.querySelectorAll(".reveal");

      reveals.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !element.classList.contains("active")
        ) {
          element.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // trigger on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);
  return (
    <>
      {/* Hero Section */}
      <AboutHeroSection
        pillText="~ We Build Future-ready Apps ~"
        title="Who We Are,"
        highlight="Innovative Tech Partners"
        description="We help startups and enterprises bring their ideas to life using cutting-edge technologies. From concept to launch, our team delivers scalable, user-friendly software."
        imageAlt="team-discussion"
      />

      {/* About Sections */}
      <section className="py-5 about-text">
        <Container>
          <AboutSection
            title="Who"
            highlight="we are"
            image={about3}
            content={[
              "Neoverce is a software technology company that partners with businesses, founders, and innovators to build cutting-edge web solutions. We turn bold ideas into scalable digital products that your customers will love and trust. With a sharp focus on usability, performance, and growth, we help you launch faster and scale smarter.",
            ]}
          />

          <AboutSection
            title="What makes us different from others,"
            highlight="you may ask.."
            image={about1}
            reverse
            content={[
              "We design and build with your end user at the center of everything. From our very first discovery call, we focus on the people or businesses you’re creating for — uncovering their goals, pain points, and behaviors through research-driven insights. This deep understanding allows us to craft solutions that don’t just work, but truly resonate.",
            ]}
          />

          <AboutSection
            title="The"
            highlight="result?"
            image={about2}
            content={[
              "We craft world-class web solutions that do more than just look good — they engage your users, solve real problems, and fuel your business growth. Every product we build is designed to connect your audience seamlessly to your value.",

              "With deep cross-industry experience and technical excellence, we build custom solutions tailored to modern challenges. Whether you’re a startup or an enterprise, we deliver digital products that stand out and scale effortlessly.",
              // "We make use of our broad expertise and in-depth understanding of many industries to create unique solutions that can address the problems that modern organizations are facing.",
            ]}
          />
        </Container>
      </section>

      <WhyUs />
      <ExperiencesCard />
    </>
  );
}
